export default "__VITE_ASSET__BhypYt4D__"